import { Suspense } from 'react';
import { PageWrapper } from '@src/components/Wrapper';
import {
    FormSkeleton,
    DataTableSkeleton,
    PageSkeleton,
} from '@src/components/ui/Skeleton';

interface ILazyLoadComponent {
    Component: React.ReactNode;
    type?: 'PAGE' | 'LIST' | 'FORM';
}
export function LazyLoadComponent({
    Component,
    type = 'PAGE',
}: ILazyLoadComponent) {
    function fallback() {
        switch (type) {
            case 'FORM':
                return (
                    <PageWrapper>
                        <FormSkeleton className="!w-auto max-w-full !shadow-none border-none" />
                    </PageWrapper>
                );
            case 'LIST':
                return (
                    <PageWrapper>
                        <div>
                            <DataTableSkeleton />
                        </div>
                    </PageWrapper>
                );

            default:
                return (
                    <PageSkeleton className="!w-auto max-sm:pb-10 max-lmd:ms-2 min-lmd:ps-0 rounded-2xl pt-8 px-6 me-2" />
                );
        }
    }
    return <Suspense fallback={fallback()}>{Component}</Suspense>;
}
